import script from "./Lista.vue?vue&type=script&setup=true&lang=js"
export * from "./Lista.vue?vue&type=script&setup=true&lang=js"

import "./Lista.vue?vue&type=style&index=0&id=0a3cbcc3&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a3cbcc3"]])

export default __exports__